module.exports = __webpack_public_path__ + "static/media/powered-by-cpgps.9daa5cbe.svg";